import React from "react";
import { Plus, Trash2 } from "lucide-react";

const blank = { name_ru: "", name_en: "", name_cn: "", price: 0 };

export default function TiersEditor({ tiers, onChange }) {
  const set = (i, k, v) => onChange(tiers.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  return (
    <div className="space-y-3" data-testid="tiers-editor">
      {tiers.map((t, i) => (
        <div key={i} className="glass-cyan rounded-xl p-3 grid grid-cols-2 sm:grid-cols-5 gap-2 items-end" data-testid={`tier-row-${i}`}>
          {["ru", "en", "cn"].map((l) => (
            <div key={l}>
              <label>Название {l.toUpperCase()}</label>
              <input value={t[`name_${l}`]} onChange={(e) => set(i, `name_${l}`, e.target.value)} className="mt-1 !py-2" data-testid={`tier-${i}-name-${l}`} />
            </div>
          ))}
          <div>
            <label>Цена ₽</label>
            <input type="number" min={0} value={t.price} onChange={(e) => set(i, "price", Number(e.target.value))} className="mt-1 !py-2" data-testid={`tier-${i}-price`} />
          </div>
          <button type="button" onClick={() => onChange(tiers.filter((_, j) => j !== i))} className="btn-outline !py-2 !px-3 justify-self-start" data-testid={`tier-${i}-remove`}>
            <Trash2 size={14} />
          </button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...tiers, { ...blank }])} className="btn-outline !py-2 !px-4 text-sm inline-flex items-center gap-2" data-testid="tier-add-btn">
        <Plus size={14} /> Добавить тариф
      </button>
    </div>
  );
}
